export const NEW_PRIMARY_COLOR = 'rgba(23, 23, 23, 1)';
export const PRIMARY_COLOR = 'rgba(35, 39, 42, 1)';
export const PRIMARY_COLOR_8_SOLID = 'rgba(79, 82, 85, 1)';
export const PRIMARY_COLOR_8 = 'rgba(35, 39, 42, .8)';
export const PRIMARY_COLOR_7 = 'rgba(35, 39, 42, .7)';
export const PRIMARY_COLOR_6 = 'rgba(35, 39, 42, .6)';
export const PRIMARY_COLOR_5 = 'rgba(35, 39, 42, .5)';
export const PRIMARY_COLOR_4 = 'rgba(35, 39, 42, .4)';
export const PRIMARY_COLOR_2 = 'rgba(35, 39, 42, .2)';
export const PRIMARY_COLOR_1 = 'rgba(35, 39, 42, .1)';
export const SECONDARY_COLOR = '#484C4D';
export const PRIMARY_TEXT = '#ffffff';
export const SECONDARY_TEXT = 'rgba(255,255,255,0.8)';
export const DETAIL_TEXT = 'rgba(255,255,255,.6)';
export const PALE_WHITE = 'rgba(255,255,255,.1)';
export const PALE_WHITE_1 = 'rgba(255,255,255,.1)';
export const PALE_WHITE_2 = 'rgba(255,255,255,.2)';
export const PALE_WHITE_3 = 'rgba(255,255,255,.3)';
export const PALE_WHITE_4 = 'rgba(255,255,255,.4)';
export const PALE_WHITE_5 = 'rgba(255,255,255,.5)';
export const PALE_WHITE_6 = 'rgba(255,255,255,.6)';
export const PALE_WHITE_8 = 'rgba(255,255,255,.8)';
export const PREVIEW_OUTLINE_BORDER = 'rgba(255,255,255,0.14)';
export const WHITE = '#ffffff';
export const PLACEHOLDER = '#606060';
export const NOTE_BACKGROUND = '#F2F2F2';
export const IMAGE_BACKGROUND = '#E2E2E2';
export const GREEN = '#00896F';
export const GREEN_OP = 'rgba(0,137,111,.6)';
export const GREEN_OP_4 = 'rgba(0,137,111,.4)';
export const GREEN_OP_2 = 'rgba(0,137,111,.2)';
export const GREEN_OP_1 = 'rgba(0,137,111,.1)';
export const RED = '#CF3D2A';
export const RED_OP = 'rgba(207, 61, 42, .6)';
export const RED_OP_1 = 'rgba(207, 61, 42, .1)';
export const HOVER_RED = '#B23221';
export const ORANGE = '#FF8C00';
export const ORANGE_OP = 'rgba(255, 140, 0, .6)';
export const YELLOW = '#FFD700';
export const YELLOW_OP = 'rgba(255, 215, 0, .6)';
export const STARRED = 'rgba(250,230,164,1)';
export const ACTION_TAG = 'rgba(0, 0, 0, 0.64)';
export const ACTION_TAG_HOVER = 'rgba(120, 120, 120, 1)';
export const LINK = '#0E7AFE';
export const BLUE_HIGHLIGHT = '#e2f0ff';
export const FILE_BLUE = '#6495ed';
export const INFO_BLUE = 'rgba(0, 133, 202, 1)';
export const INFO_BLUE_OP = 'rgba(0, 133, 202, .6)';
export const INFO_BLUE_OP_4 = 'rgba(0, 133, 202, .4)';
export const INFO_BLUE_OP_2 = 'rgba(0, 133, 202, .2)';
export const LIMITED_OFFER_BANNER ='rgb(102, 126, 234)';
export const LIMITED_OFFER_BANNER_OP ='rgba(102, 126, 234, .4)';
export const LIMITED_OFFER_BANNER_OP3 ='rgba(102, 126, 234, .3)';
// export const LIMITED_OFFER_BANNER ='rgba(250,230,164,1)';
// export const LIMITED_OFFER_BANNER_OP ='rgba(250,230,164,.5)';
// export const LIMITED_OFFER_BANNER_OP3 ='rgba(250,230,164,.3)';

// BEGIN SHARED CONTENT COLORS
// Shared by entity tags, Browse filters, artifact cards and previews.
export const ENTITY_COLORS = {
    book: { bg: 'rgba(139, 90, 43, 0.18)', border: 'rgba(139, 90, 43, 0.35)', text: '#c8a26b' },
    movie: { bg: 'rgba(80, 60, 140, 0.18)', border: 'rgba(80, 60, 140, 0.35)', text: '#9b8de8' },
    tv_show: { bg: 'rgba(60, 80, 160, 0.18)', border: 'rgba(60, 80, 160, 0.35)', text: '#7ea8f0' },
    article: { bg: 'rgba(40, 110, 80, 0.18)', border: 'rgba(40, 110, 80, 0.35)', text: '#6bbf99' },
    product: { bg: 'rgba(160, 60, 60, 0.18)', border: 'rgba(160, 60, 60, 0.35)', text: '#e88a8a' },
    event: { bg: 'rgba(160, 100, 30, 0.18)', border: 'rgba(160, 100, 30, 0.35)', text: '#e8b96b' },
    workout: { bg: 'rgba(40, 140, 80, 0.18)', border: 'rgba(40, 140, 80, 0.35)', text: '#6bdf99' },
    person: { bg: 'rgba(60, 100, 160, 0.18)', border: 'rgba(60, 100, 160, 0.35)', text: '#7ab0e8' },
    company: { bg: 'rgba(100, 60, 140, 0.18)', border: 'rgba(100, 60, 140, 0.35)', text: '#b88add' },
    recipe: { bg: 'rgba(165, 85, 66, 0.18)', border: 'rgba(165, 85, 66, 0.35)', text: '#db8b78' },
    place: { bg: 'rgba(40, 120, 120, 0.18)', border: 'rgba(40, 120, 120, 0.35)', text: '#6bc8c8' },
    app: { bg: 'rgba(20, 100, 160, 0.18)', border: 'rgba(20, 100, 160, 0.35)', text: '#60b8e8' },
    game: { bg: 'rgba(120, 40, 120, 0.18)', border: 'rgba(120, 40, 120, 0.35)', text: '#d880d8' },
    music: { bg: 'rgba(160, 40, 100, 0.18)', border: 'rgba(160, 40, 100, 0.35)', text: '#e880b8' },
    podcast: { bg: 'rgba(100, 60, 20, 0.18)', border: 'rgba(100, 60, 20, 0.35)', text: '#c89a5a' },
    tutorial: { bg: 'rgba(30, 120, 60, 0.18)', border: 'rgba(30, 120, 60, 0.35)', text: '#5dc88a' },
    other: { bg: 'rgba(80, 80, 80, 0.18)', border: 'rgba(80, 80, 80, 0.35)', text: '#aaaaaa' }
};

// Artifact names that share an existing tag palette.
ENTITY_COLORS.film = ENTITY_COLORS.movie;
ENTITY_COLORS.repair = ENTITY_COLORS.tutorial;
ENTITY_COLORS.procedure = ENTITY_COLORS.tutorial;
ENTITY_COLORS.shopping_list = ENTITY_COLORS.recipe;
ENTITY_COLORS.packing_list = ENTITY_COLORS.place;
ENTITY_COLORS.checklist = ENTITY_COLORS.workout;

// Browse source/type colors; entity categories reuse the tag palette above.
export const CONTENT_PRESET_COLORS = {
    stack: {
        'web-pages': '#7FB6FF', articles: ENTITY_COLORS.article.text, books: ENTITY_COLORS.book.text, apps: ENTITY_COLORS.app.text,
        'tv-shows': ENTITY_COLORS.tv_show.text, screenshots: '#C6A6FF', videos: '#FF8FB1',
        'youtube-videos': '#FF4D4D', 'instagram-posts': '#FF8A5B', 'tiktok-posts': '#57E6E6',
        'pinterest-pins': '#E60023', 'linkedin-posts': '#6CB6FF', 'reddit-posts': '#FF7A45',
        'facebook-posts': '#7AA2FF', 'bluesky-posts': '#1185FE', 'threads-posts': '#F3F0EA',
        'substack-posts': '#FF6719', 'x-posts': '#F2F5F7', 'x-articles': '#F2F5F7',
        'pdf-docs': '#FF7D7D', products: ENTITY_COLORS.product.text, games: ENTITY_COLORS.game.text, movies: ENTITY_COLORS.movie.text,
        recipes: ENTITY_COLORS.recipe.text, music: ENTITY_COLORS.music.text, 'voice-notes': '#59D4C8',
        repositories: '#F2F5F7', wikipedia: '#D7E7F7', newsletters: '#FFD36E',
        podcasts: ENTITY_COLORS.podcast.text, places: ENTITY_COLORS.place.text, workouts: ENTITY_COLORS.workout.text,
        events: ENTITY_COLORS.event.text, tutorials: ENTITY_COLORS.tutorial.text,
    },
    type: {
        emails: '#89B7F5', audio: '#FF9AE0', chat: '#C6A6FF', files: '#7BD7FF', images: '#7EE081',
        videos: '#FF8C7A', links: '#7FB6FF', notes: '#FFD36E', stars: '#F2C46C',
        tasks: '#5FD0A5', text: '#F2F5F7', threads: '#59D4C8',
    },
};
// END SHARED CONTENT COLORS
